var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"plain":"","color":"primary","exact":"","to":{ name: _vm.RouteName, params: _vm.routeParams }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-left")]),_vm._v("Return "+_vm._s(_vm.ReturnToText)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }